import { useMemo } from "react";
import { Card, CardContent, Typography, Box, Stack, LinearProgress, Chip } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const MEDAL_COLORS = ['#FFD700', '#C0C0C0', '#CD7F32'];

export const RankingProcesos = ({ data }) => {
  const ranking = useMemo(() => {
    const map = {};
    (data || []).forEach((r) => {
      const cant = parseInt(r.cantidad, 10) || 0;
      if (!map[r.proceso]) map[r.proceso] = 0;
      map[r.proceso] += cant;
    });
    return Object.entries(map)
      .map(([proceso, total]) => ({ proceso, total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 10);
  }, [data]);

  if (ranking.length === 0) return null;

  const max = ranking[0]?.total || 1;
  const totalGlobal = ranking.reduce((s, r) => s + r.total, 0);

  return (
    <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" mb={2}>
          <EmojiEventsIcon color="warning" />
          <Typography variant="h6" fontWeight={700}>Ranking de procesos</Typography>
        </Stack>

        <Stack spacing={1.5}>
          {ranking.map((r, i) => {
            const pct = Math.round((r.total / max) * 100);
            const share = totalGlobal > 0 ? Math.round((r.total / totalGlobal) * 100) : 0;
            const barColor = i === 0 ? 'warning' : i === 1 ? 'info' : 'primary';

            return (
              <Box key={r.proceso}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    {i < 3 ? (
                      <EmojiEventsIcon sx={{ fontSize: 16, color: MEDAL_COLORS[i] }} />
                    ) : (
                      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 16, textAlign: 'center' }}>
                        {i + 1}
                      </Typography>
                    )}
                    <Typography variant="body2" fontWeight={i === 0 ? 700 : 500} noWrap>
                      {r.proceso}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.75} alignItems="center">
                    <Chip label={r.total.toLocaleString('es-AR')} size="small" color={barColor} variant="outlined" />
                    <Typography variant="caption" color="text.secondary">{share}%</Typography>
                  </Stack>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  color={barColor}
                  sx={{ height: 6, borderRadius: 3 }}
                />
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};
